/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Error_No_Action_TypeInputs */

const cs_workflow_error_no_action_type = /** @type {(inputs: Workflow_Error_No_Action_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každý akční uzel potřebuje typ akce.`)
};

const en_workflow_error_no_action_type = /** @type {(inputs: Workflow_Error_No_Action_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every action node needs an action type.`)
};

/**
* | output |
* | --- |
* | "Every action node needs an action type." |
*
* @param {Workflow_Error_No_Action_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_error_no_action_type = /** @type {((inputs?: Workflow_Error_No_Action_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Error_No_Action_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_error_no_action_type(inputs)
	return cs_workflow_error_no_action_type(inputs)
});